export function isEmpty(value) {
  return value === undefined || value === null || value.length === 0 || value === '<p><br></p>';
}
